import React from 'react';
import PageContent from '../../components/page-content';
import { ProductCollection as ProductCollectionType } from '../../types';
import ProductCollectionSlice from './components/slice';

type Props = {
  data: {
    productCollection: ProductCollectionType;
  };
};

const ProductCollection = ({ data }: Props) => (
  <PageContent withAds>
    {data.productCollection?.slices?.map(slice => (
      <ProductCollectionSlice
        key={`${slice.id}_${slice.__typename}`}
        slice={slice}
        productCollection={data.productCollection}
      />
    ))}
  </PageContent>
);

export default ProductCollection;
